module.exports = __webpack_public_path__ + "media/v2/components/Contests/shared/Image/arrowPrevious-876e56fb0445b1d4fc3a668a0ae209ea.svg";